export default {
  clientes: [],
  clientesFiltros: [],
  totalClientes: 0,
  clientesExport: [],
  clientesFiltersExport: [],
}